import { setDoc, doc, serverTimestamp } from "firebase/firestore";
import { AppFirebase, database } from "../../../config/firebase";

export const saveOnWatching = async (data, minutesWatched, episodes, setEpisodesWatching) => {
    
    const profileUid = localStorage.getItem("profile_uid");
    console.log(data)

    try {
    
        if (data?.media_type === 'tv') {
            
            // Verifica se 'episodes' é um array e copia corretamente
            const episodesDocs = Array.isArray(episodes) ? [...episodes] : [];
            
            const newEpisode = {
                episode_duration: Number(data?.episode_details?.runtime * 60),
                episode_seconds_watched: minutesWatched,
                episode_id: Number(data?.episode_details?.id),
                episode_number: Number(data?.episode_details?.episode_number),
                season_number: Number(data?.season_number),
                player: data?.player,
                updated: new Date(),
            };

            // Verifica se o episódio já existe
            const episodeIndex = episodesDocs.findIndex(episode => episode.episode_id === newEpisode.episode_id);

            if (episodeIndex !== -1) {
                // Sobrescreve o episódio existente
                episodesDocs[episodeIndex] = newEpisode;
            } else {
                // Adiciona o novo episódio
                episodesDocs.push(newEpisode);
            }

            console.log("data:", data)

            await setDoc(doc(database, `profiles/${profileUid}/playlists/watching/movies/${data?.id_imdb}`), {
                name: data?.name,
                media_type: data?.media_type,
                episode_duration: Number(data?.episode_details?.runtime * 60),
                episode_seconds_watched: minutesWatched,
                episode_id: Number(data?.episode_details?.id),
                episode_number: Number(data?.episode_details?.episode_number),
                backdrop_path: data?.backdrop_path,
                logo_path: data?.logo_path,
                season_number: Number(data?.season_number),
                player: data?.player,
                movie_id_tmdb: data.id_tmdb,
                movie_id_imdb: data.id_imdb,
                display: true,
                updated: serverTimestamp(),
                version: 'moov',
            });

            await setDoc(doc(database, `profiles/${profileUid}/playlists/watching/movies/${data?.id_imdb}/seasons/${data?.season_number}`), {
                season_number: data?.season_number,
                episodes: episodesDocs,
                updated: serverTimestamp(),
            });

            setEpisodesWatching(episodesDocs);
        } else {
            // Adicionando documento de filme
            await setDoc(doc(database, `profiles/${profileUid}/playlists/watching/movies/${data?.id_imdb}`), {
                name: data?.name,
                runtime: data?.more_details?.runtime,
                release_date: data?.more_details?.release_date,
                movie_duration: Number(data?.more_details?.runtime * 60),
                movie_seconds_watched: minutesWatched,
                media_type: "movie",
                backdrop_path: data?.backdrop_path,
                logo_path: data?.logo_path,
                player: data?.player,
                movie_id_tmdb: data.id_tmdb,
                movie_id_imdb: data.id_imdb,
                display: true,
                updated: serverTimestamp(),
                version: 'moov',
            });

        }
    } catch (e) {
        console.error("Erro ao adicionar o documento: ", e);
    }
};

export const removeEpisodeFromWatching = async (data, episodesWatching, setEpisodesWatching, movie_id_imdb) => {
    
    const profileUid = localStorage.getItem("profile_uid");

    try {
        console.log("Episodes watching", episodesWatching)
        // Filtra os episódios para remover o desejado
        const updatedEpisodes = episodesWatching?.filter(episode => episode?.episode_id !== data?.episode_id);

        console.log("data:", data)
        console.log("updatedEpisodes:", updatedEpisodes)

        // Atualiza o documento no Firestore
        await setDoc(doc(database, `profiles/${profileUid}/playlists/watching/movies/${movie_id_imdb}/seasons/${data?.episode_details?.season_number}`), {
            season_number: data?.episode_details?.season_number,
            episodes: updatedEpisodes,
            updated: serverTimestamp(),
        });

        // Atualiza o estado local
        setEpisodesWatching(updatedEpisodes);
        console.log(`Episódio "${data?.episode_details?.name}" com id "${data?.episode_details?.id}" foi removido com sucesso dos assistidos.`);
    } catch (e) {
        console.error("Erro ao remover o episódio: ", e);
    }
};